<template>
  <div
    v-if="!disabled"
    class="tw-w-full tw-flex tw-justify-center tw-my-5 sm:tw-my-10"
    :style="{ 'grid-column': '1/-1' }"
  >
    <base-button primary :status="status" @click="$emit('fetch:more')">{{
      $t('show_more')
    }}</base-button>
  </div>
  <loading-item-cards
    v-else-if="loading && !total"
    :count="loadingCardCount * 3"
  />
</template>

<script>
import LoadingItemCards from '@components/Loading/LoadingItemCards.vue'
import { useBrowseContainer, useStatus } from '@composables'
import { toRefs, watch } from 'vue'
export default {
  components: {
    LoadingItemCards,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  emits: ['fetch:more'],
  setup(props) {
    const { loading } = toRefs(props)
    const { loadingCardCount } = useBrowseContainer()

    const { status, clearStatus } = useStatus({ loading })
    watch(loading, (_loading, _oldLoading) => {
      if (!_loading && _oldLoading) {
        clearStatus()
      }
    })
    return {
      loadingCardCount,
      status,
    }
  },
}
</script>
